import { useQuery } from "@tanstack/react-query"
import { campaignLogsQuery } from "../lib/campaignLogsQuery"

export function useCampaignLogsQuery(...args: Parameters<typeof campaignLogsQuery>) {
  return useQuery(campaignLogsQuery(...args))
}
